<script setup lang="ts">
import type { Schemas } from "#shopware";
import { createCategoryListingContext, useNavigationContext } from '#imports'

defineProps<{
    content: Schemas["CmsPage"];
}>();

// required to use useCategoryListing composable
const { routeName } = useNavigationContext();
if (routeName.value === "frontend.navigation.page") {
    createCategoryListingContext();
}
</script>

<template>
    <div class="grid pt-3 pb-8 gap-4 md:gap-8 md:pt-8 md:pb-14">
        <StructureSection
            v-for="(section, index) in content.sections"
            :key="index"
            :count="index"
            :content="section"
        />
    </div>
</template>
